export const COMPANY_PROFILE_ANY_REQUEST = 'COMPANY_PROFILE_ANY_REQUEST';
export const COMPANY_PROFILE_ANY_FAILED = 'COMPANY_PROFILE_ANY_FAILED';

export const GET_COMPANY_TOPICS_SUCCESS = 'GET_COMPANY_TOPICS_SUCCESS';
export const GET_COMPANY_QUESTIONS_SUCCESS = 'GET_COMPANY_QUESTIONS_SUCCESS';
export const GET_COMPANY_ANSWERS_SUCCESS = 'GET_COMPANY_ANSWERS_SUCCESS';
export const GET_COMPANY_NEWS_SUCCESS = 'GET_COMPANY_NEWS_SUCCESS';
export const GET_COMPANY_QUESTIONS_IMPROVE_SUCCESS = 'GET_COMPANY_QUESTIONS_IMPROVE_SUCCESS';
